import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from "@angular/core";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { ObjDetailsData } from "../s25.object.details.component";
import { ContactService } from "../../../services/contact.service";
import { Bind } from "../../../decorators/bind.decorator";
import { Item } from "../../../pojo/Item";
import { Contact } from "../../../pojo/Contact";
import { OrgDetailData } from "../../../pojo/OrganizationI";
import { OrganizationService } from "../../../services/organization.service";
import { S25Util } from "../../../util/s25-util";
import { EventDetailData } from "../../s25-event/EventMicroI";
import { EventMicroService } from "../../../services/event.micro.service";
import { DropDownItem } from "../../../pojo/DropDownItem";

@TypeManagerDecorator("s25-ng-object-details-general")
@Component({
    selector: "s25-ng-object-details-general",
    template: `
        @switch (itemTypeId) {
            @case (itemTypeIds.Contact) {
                <ng-container *ngTemplateOutlet="contact"></ng-container>
            }
            @case (itemTypeIds.Organization) {
                <ng-container *ngTemplateOutlet="org"></ng-container>
            }
            @case (itemTypeIds.Event) {
                <ng-container *ngTemplateOutlet="event"></ng-container>
            }
        }

        <!-- Object-specific templates -->
        <ng-template #org>
            @if (!!orgModel.type || canEdit) {
                <div>
                    <label>Type</label>
                    @if (canEdit) {
                        <s25-ng-dropdown-search-criteria
                            [type]="'organizationTypes'"
                            [(chosen)]="orgModel.type"
                            [ariaLabel]="'Org Type'"
                            (chosenChange)="save('type')"
                        ></s25-ng-dropdown-search-criteria>
                    } @else {
                        <p>{{ orgModel.type.itemName }}</p>
                    }
                </div>
                @if (!!orgModel.rating?.itemName || orgModel.canEditRating) {
                    <div>
                        <label>Rating</label>
                        @if (canEdit && orgModel.canEditRating) {
                            <s25-ng-dropdown-search-criteria
                                [type]="'organizationRatings'"
                                [(chosen)]="orgModel.rating"
                                [ariaLabel]="'Rating'"
                                (chosenChange)="save('rating')"
                            ></s25-ng-dropdown-search-criteria>
                        } @else if (!canEdit || !orgModel.canEditRating) {
                            <p>{{ orgModel.rating.itemName }}</p>
                        }
                    </div>
                }
                @if (!!orgModel.orgNumber || orgModel.canEditAcctCode) {
                    <div>
                        <label>Accounting Code</label>
                        @if (canEdit && orgModel.canEditAcctCode) {
                            <s25-ng-editable-text
                                [val]="orgModel.orgNumber"
                                [max]="40"
                                [hasCommit]="true"
                                [onCommit]="save"
                                [ariaLabel]="'Accounting Code'"
                                (valChange)="onUpdate($event, 'organization_number')"
                            ></s25-ng-editable-text>
                        } @else if (!canEdit || !orgModel.canEditAcctCode) {
                            <p>{{ orgModel.orgNumber }}</p>
                        }
                    </div>
                }
            }
        </ng-template>
        <ng-template #contact>
            <div>
                <label for="contact-name">Contact Name </label>
                <p id="contact-name">{{ contactModel.contactName }}</p>
            </div>
            @if (canEdit) {
                <div>
                    <label>First Name</label>
                    <s25-ng-editable-text
                        [val]="contactModel.firstName"
                        [max]="40"
                        [hasCommit]="true"
                        [onCommit]="save"
                        [ariaLabel]="'First Name'"
                        (valChange)="onUpdate($event, 'first_name')"
                    ></s25-ng-editable-text>
                </div>
                <div>
                    <label> Middle Name </label>
                    <s25-ng-editable-text
                        [val]="contactModel.middleName"
                        [max]="80"
                        [hasCommit]="true"
                        [onCommit]="save"
                        [ariaLabel]="'Middle Name'"
                        (valChange)="onUpdate($event, 'middle_name')"
                    ></s25-ng-editable-text>
                </div>
                <div>
                    <label> Last Name </label>
                    <s25-ng-editable-text
                        [val]="contactModel.lastName"
                        [max]="40"
                        [hasCommit]="true"
                        [onCommit]="save"
                        [ariaLabel]="'Last Name'"
                        (valChange)="onUpdate($event, 'last_name')"
                    ></s25-ng-editable-text>
                </div>
            }
            @if (contactModel.namePrefix || canEdit) {
                <div>
                    <label> Prefix </label>
                    <s25-ng-editable-text
                        [val]="contactModel.namePrefix"
                        [max]="20"
                        [readOnly]="!canEdit"
                        [hasCommit]="true"
                        [onCommit]="save"
                        [ariaLabel]="'Prefix'"
                        (valChange)="onUpdate($event, 'name_prefix')"
                    ></s25-ng-editable-text>
                </div>
            }
            @if (contactModel.nameSuffix || canEdit) {
                <div>
                    <label> Suffix </label>
                    <s25-ng-editable-text
                        [val]="contactModel.nameSuffix"
                        [max]="20"
                        [readOnly]="!canEdit"
                        [hasCommit]="true"
                        [onCommit]="save"
                        [ariaLabel]="'Suffix'"
                        (valChange)="onUpdate($event, 'name_suffix')"
                    ></s25-ng-editable-text>
                </div>
            }
            @if (contactModel.nameSuffix || canEdit) {
                <div>
                    <label> Title </label>
                    <s25-ng-editable-text
                        [val]="contactModel.title"
                        [max]="40"
                        [readOnly]="!canEdit"
                        [hasCommit]="true"
                        [onCommit]="save"
                        [ariaLabel]="'Title'"
                        (valChange)="onUpdate($event, 'title')"
                    ></s25-ng-editable-text>
                </div>
            }
            @if (contactModel.internalId || canEdit) {
                <div>
                    <label> Internal ID </label>
                    <s25-ng-editable-text
                        [val]="contactModel.internalId"
                        [max]="30"
                        [readOnly]="!canEdit"
                        [hasCommit]="true"
                        [onCommit]="save"
                        [ariaLabel]="'Internal ID'"
                        (valChange)="onUpdate($event, 'internal_id')"
                    ></s25-ng-editable-text>
                </div>
            }
        </ng-template>
        <ng-template #event>
            <div>
                <label> Event Name </label>
                <s25-ng-editable-text
                    [val]="eventModel.name"
                    [max]="40"
                    [readOnly]="!canEdit"
                    [hasCommit]="true"
                    [onCommit]="save"
                    [ariaLabel]="'Event Name'"
                    (valChange)="onUpdate($event, 'name')"
                ></s25-ng-editable-text>
            </div>
            @if (eventModel.title || canEdit) {
                <div>
                    <label> Event Title </label>
                    <s25-ng-editable-text
                        [val]="eventModel.title"
                        [max]="120"
                        [readOnly]="!canEdit"
                        [hasCommit]="true"
                        [onCommit]="save"
                        [ariaLabel]="'Event Title'"
                        (valChange)="onUpdate($event, 'title')"
                    ></s25-ng-editable-text>
                </div>
            }
            <div>
                <label>Event Type</label>
                <s25-ng-dropdown-search-criteria
                    [type]="'eventTypes'"
                    [chosen]="eventModel.eventType"
                    [readOnly]="!canEdit"
                    [placeholder]="'Select Event Type'"
                    [useSecurity]="true"
                    (chosenChange)="onUpdate($event, 'context'); save()"
                ></s25-ng-dropdown-search-criteria>
            </div>
            @if (eventModel.primaryOrg?.itemId || canEdit) {
                <div class="primary-org">
                    <label>Organization</label>
                    @if (canEdit) {
                        <s25-ng-dropdown-search-criteria
                            [type]="'organizations'"
                            [chosen]="eventModel.primaryOrg.itemId ? eventModel.primaryOrg : undefined"
                            [placeholder]="'Select Organization'"
                            [useSecurity]="true"
                            [blockDetailsNav]="true"
                            (chosenChange)="onUpdate($event, 'organizations'); save()"
                        ></s25-ng-dropdown-search-criteria>
                    } @else {
                        <s25-item-organization
                            [modelBean]="{
                                itemId: +eventModel.primaryOrg?.itemId,
                                itemName: eventModel.primaryOrg?.itemName,
                            }"
                            [includeTypeIcon]="true"
                            [hideLabel]="true"
                        ></s25-item-organization>
                    }
                </div>
            }
            @if (eventModel.addtlOrgs?.length || canEdit) {
                <div class="addtl-orgs">
                    <label>Additional Organizations</label>
                    <s25-ng-editable-additional-orgs
                        [itemId]="itemId"
                        [addtlOrgs]="eventModel.addtlOrgs"
                        [editable]="canEdit"
                    ></s25-ng-editable-additional-orgs>
                </div>
            }
            @if (eventModel.contactRoles?.assignedRoles?.length || canEdit) {
                <s25-ng-editable-contact-roles
                    [itemId]="itemId"
                    [contacts]="eventModel.contactRoles?.assignedRoles"
                    [eventTypeRoles]="eventModel.contactRoles?.eventTypeRoles"
                    [editable]="canEdit"
                ></s25-ng-editable-contact-roles>
            }
            <div [class.multi-headcount]="eventModel.headCount?.length > 1">
                <label>Head Count</label>
                <s25-ng-editable-headcount
                    [counts]="eventModel.headCount"
                    [canEdit]="canEdit"
                    [itemId]="itemId"
                ></s25-ng-editable-headcount>
            </div>
            @if (eventModel.text?.description || canEdit) {
                <div class="evdetail-text">
                    <label>Description</label>
                    <s25-ng-object-details-editable-text
                        [itemId]="itemId"
                        [itemTypeId]="itemTypeId"
                        [canEdit]="canEdit"
                        [type]="'richtext'"
                        [prop]="'description'"
                        [data]="eventModel.text?.description ?? ''"
                    ></s25-ng-object-details-editable-text>
                </div>
            }
            @if (eventModel.text?.comments?.[0]?.comments || canEdit) {
                <div class="evdetail-text" [class.multi-comments]="eventModel.text?.comments?.length > 1">
                    <label>Comments</label>
                    <s25-ng-object-details-editable-text
                        [itemId]="itemId"
                        [itemTypeId]="itemTypeId"
                        [canEdit]="canEdit"
                        [prop]="'profiles'"
                        [type]="'multi-textarea'"
                        [profiles]="eventModel.text?.comments"
                    ></s25-ng-object-details-editable-text>
                </div>
            }
            @if (eventModel.text?.note || canEdit) {
                <div class="evdetail-text">
                    <label>Internal Notes</label>
                    <s25-ng-object-details-editable-text
                        [itemId]="itemId"
                        [itemTypeId]="itemTypeId"
                        [canEdit]="canEdit"
                        [type]="'textarea'"
                        [prop]="'note'"
                        [data]="eventModel.text?.note ?? ''"
                    ></s25-ng-object-details-editable-text>
                </div>
            }
            @if (eventModel.text?.confirmation || canEdit) {
                <div class="evdetail-text">
                    <label>Confirmation Text</label>
                    <s25-ng-object-details-editable-text
                        [itemId]="itemId"
                        [itemTypeId]="itemTypeId"
                        [canEdit]="canEdit"
                        [type]="'textarea'"
                        [prop]="'confirmation'"
                        [data]="eventModel.text?.confirmation ?? ''"
                    ></s25-ng-object-details-editable-text>
                </div>
            }
            @if (eventModel.attachments?.files?.length || canEdit) {
                <div class="attachments">
                    <label>Attached Files</label>
                    <s25-ng-editable-file
                        [model]="eventModel.attachments"
                        [canEdit]="canEdit"
                        [excludeCustAttrFiles]="true"
                    ></s25-ng-editable-file>
                </div>
            }
        </ng-template>
    `,
    host: {
        class: "general-details-wrapper",
        "[class.read-only]": "!canEdit",
        "[class.org-details]": "itemTypeId === itemTypeIds.Organization",
        "[class.contact-details]": "itemTypeId === itemTypeIds.Contact",
    },
    styles: `
        :host {
            display: flex;
            flex-direction: column;
            gap: 8px;

            .addtl-orgs {
                align-items: start;
                margin-top: 5px;
            }

            s25-ng-object-details-editable-text {
                padding: 0;
            }

            .evdetail-text {
                label {
                    position: relative;
                    top: 0.5em;
                }

                &.multi-comments {
                    display: flex;
                    flex-direction: column;
                    gap: 10px;

                    s25-ng-object-details-editable-text {
                        width: 98%;
                        margin-left: auto;
                    }
                }
            }
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class S25ObjectDetailsGeneralComponent {
    @Input({ required: true }) model: ObjDetailsData["general"];
    @Input({ required: true }) itemTypeId: Item.Id;
    @Input({ required: true }) itemId: number;
    @Input({ required: true }) canEdit: boolean;

    dataToUpdate: { prop: string; value: PayloadVal };
    itemTypeIds = Item.Ids;
    payloadPropMap: Record<string, string> = {
        context: "typeId",
        organizations: "primary",
    };

    constructor(private cd: ChangeDetectorRef) {}

    @Bind
    save(param?: string) {
        try {
            switch (this.itemTypeId) {
                case Item.Ids.Contact:
                    return this.saveContact();
                case Item.Ids.Organization:
                    return this.saveOrg(param);
                case Item.Ids.Event:
                    return this.saveEvent();
            }
            this.dataToUpdate = null;
        } catch (error) {
            console.error(error);
        }
    }

    @Bind
    onUpdate(value: PayloadVal, prop: string) {
        this.dataToUpdate = { prop, value };
    }

    async saveContact() {
        const { prop, value } = this.dataToUpdate;
        const resp = await ContactService.putContactMinimal(this.itemId, { [prop]: value });
        const props = ["first_name", "middle_name", "last_name"];
        if (resp?.results?.info?.msg_id === "CO_I_SAVE" && props.includes(prop)) {
            const name = await ContactService.getContactName(this.itemId);
            if (name) this.contactModel.contactName = name;
            this.cd.markForCheck();
        }
    }

    async saveOrg(propName: string) {
        let payload;
        const { type, origType, rating } = this.orgModel;

        if (propName === "type") {
            payload = {
                organization_type: {
                    type_id: type.itemId,
                    type_name: type.itemName,
                    status: !!origType ? "mod" : "new",
                },
            };
        } else if (propName === "rating") {
            payload = {
                rating_id: rating.itemId,
                rating_name: rating.itemName,
            };
        } else {
            const { prop, value } = this.dataToUpdate ?? {};
            if (value?.toString() === this.orgModel.orgNumber?.toString()) return;
            payload = {
                [prop]: value,
            };
        }
        const [_, error] = await S25Util.Maybe(OrganizationService.putOrganization(this.itemId, payload));
        if (error) S25Util.showError(error);
    }

    async saveEvent() {
        let { prop, value } = this.dataToUpdate ?? {};
        const dropDownVal = value as DropDownItem;
        if (this.payloadPropMap[prop]) {
            // some values are strings, and some are dropdown objects
            if (
                !dropDownVal?.itemId ||
                this.eventModel[prop === "context" ? "eventType" : "primaryOrg"]?.itemId === dropDownVal?.itemId
            )
                return;
            value = { [this.payloadPropMap[prop]]: +dropDownVal.itemId };
        } else if (this.eventModel[prop as "title" | "name"] === value) return;

        const payload = {
            items: [{ id: this.itemId, [prop]: value }],
        };
        const [_, error] = await S25Util.Maybe(EventMicroService.microPutEventDetail(payload, this.itemId));
        if (error) return S25Util.showError(error);
        if (this.payloadPropMap[prop]) {
            this.eventModel[prop === "context" ? "eventType" : "primaryOrg"] = {
                itemId: dropDownVal.itemId,
                itemName: dropDownVal.itemName,
            };
        } else {
            this.eventModel[prop as "title" | "name"] = value as string;
        }
    }

    get contactModel() {
        return this.model as Contact.DetailData["general"];
    }

    get orgModel() {
        return this.model as OrgDetailData["general"];
    }

    get eventModel() {
        return this.model as EventDetailData["general"];
    }
}

type PayloadVal = string | Record<string, number> | { itemId: number };
